/** Value stored in the plans table for "no limit". */
export const UNLIMITED = -1;

export function isUnlimited(max) {
    return Number(max) === UNLIMITED;
}

export function formatLimit(max) {
    return isUnlimited(max) ? 'Unlimited' : max;
}

/**
 * Compact one-line summary of the secondary caps, for the already wide plans
 * table. "∞" marks an unlimited value.
 */
export function formatFeatureLimits(plan) {
    const short = max => (isUnlimited(max) ? '∞' : max);
    return [
        `ix ${short(plan.maxIndexes)}`,
        `grid ${short(plan.maxGridLevels)}`,
        `act ${short(plan.maxActions)}`,
        `bt ${short(plan.maxBacktestDays)}d/${short(plan.maxBacktestCandles)}c`,
        `ntf ${short(plan.maxNotificationsPerHour)}/h`,
        `ws ${short(plan.maxWsConnections)}`,
    ].join(' · ');
}
